import { SCHEMA_VERSIONS } from "../constants/schemaVersions";
import { isOperationType } from "../valueObjects/operationTypes";
import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createCrewSnapshot = ({ userId, name, role }) => {
  assertString(name, "crewSnapshot.name");
  assertString(role, "crewSnapshot.role");

  return {
    userId,
    name,
    role,
  };
};

export const createTrip = ({
  id = createUuid(),
  voyageId,
  sequence,
  operationType,
  status = "planned",
  date,
  portId,
  portNameSnapshot = "",
  jettyId,
  jettyNameSnapshot = "",
  counterpartyId,
  counterpartyNameSnapshot = "",
  charterPartyDate,
  masterSnapshot,
  chiefOfficerSnapshot,
  createdAt = nowIso(),
  createdBy,
  updatedAt = createdAt,
  updatedBy,
  amendedAt,
  amendedBy,
  amendmentReason,
  revision = 1,
}) => {
  assertString(id, "trip.id");
  assertString(voyageId, "trip.voyageId");
  assertString(date, "trip.date");
  assertString(createdBy, "trip.createdBy");
  assertString(updatedBy || createdBy, "trip.updatedBy");

  if (!isOperationType(operationType)) {
    throw new Error("trip.operationType must be a valid operation type");
  }

  return {
    id,
    voyageId,
    sequence,
    operationType,
    status,
    date,
    portId,
    portNameSnapshot,
    jettyId,
    jettyNameSnapshot,
    counterpartyId,
    counterpartyNameSnapshot,
    charterPartyDate,
    masterSnapshot,
    chiefOfficerSnapshot,
    createdAt,
    createdBy,
    updatedAt,
    updatedBy: updatedBy || createdBy,
    amendedAt,
    amendedBy,
    amendmentReason,
    revision,
    schemaVersion: SCHEMA_VERSIONS.TRIP,
  };
};
